module.exports = __webpack_public_path__ + "img/table-list.b8c9b10d.svg";